var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{staticClass:"uk-form-label"},[_vm._t("default"),(_vm.required)?_c('span',{staticClass:"uk-text-danger"},[_vm._v("*")]):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }